import { mapGetters, mapActions } from 'vuex'

export const Computed = {
  ...mapGetters('deviceShifts', ['cachedShifts', 'selectedShift']),
}

export const Methods = mapActions('deviceShifts', [
  'fetchShifts',
  'selectShift',
  'updateShift',
  'updateShiftPattern',
])
